module.exports = __webpack_public_path__ + "static/media/signage-indoor-img16.0a142d8d.jpg";